export default __webpack_public_path__ + "assets/112e2486d3bf86a59d2e765162e055c3.png";